/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Icon, message, Pagination, Radio} from 'antd'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import cookie from 'react-cookies'
import CRM from '../BaseComponent/CRM'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
const RadioGroup = Radio.Group

class EditCrm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      orderDate: null,
      orderDateTo: null,
      deliveryDate: null,
      deliveryDateTo: null,
      mediaList: [],
      categoryList: [],
      subjectList: [],
      definitionList: [],
      priorityList: [],
      searchByCustomerCode: false,
      searchByInvoiceNumber: false,
      current: 1,
      pageSize: 10,
      searchedCustomer: [],
      partSearchedCustomer: [],
      selectedRadio: '',
      showTable: false,
      selectedCustomerName: '',
      selectedCustomerLastName: '',
      selectedCustomerCode: '',
      selectedCustomerMobile: '',
      readOnlyField: false,
      customerId: '',
      invoiceId: '',
      invoiceNum: '',
      test: ''
    }
  }

  componentDidMount() {
    if (!cookie.load('accessToken')) {
      window.location.assign('./')
    }
    let {CrmId} = this.props.match.params
    alert(CrmId)

    http.get(`${CRM.CRM_CONTACT_MEDIA_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          mediaList: response.data.object
        })
      } else {
        this.setState({
          mediaList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_CATEGORY_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response.data))
      if (response.data.error == null) {
        this.setState({
          categoryList: response.data.object
        })
      } else {
        this.setState({
          categoryList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          subjectList: response.data.object
        })
      } else {
        this.setState({
          subjectList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          definitionList: response.data.object
        })
      } else {
        this.setState({
          definitionList: []
        })
      }
    })

    http.get(`${CRM.CRM_CONTACT_PRIORIRT_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response))
      if (response.data.error == null) {
        this.setState({
          priorityList: response.data.object
        })
      } else {
        this.setState({
          priorityList: []
        })
      }
    })
  }

  changeCategory(e) {
    let value = e.target.value

    http.get(`${CRM.CRM_CONTACT_SUBJECT_LIST}?input_ContactCategoryId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          subjectList: response.data.object
        })
      } else {
        this.setState({
          subjectList: []
        })
      }
    })
  }

  changeSubject(e) {
    let value = e.target.value

    http.get(`${CRM.CRM_CONTACT_DEFINITION_LIST}?input_ContactSubjectId=${value}`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          definitionList: response.data.object
        })
      } else {
        this.setState({
          definitionList: []
        })
      }
    })
  }

  orderDateEl(props) {
    return <input className="form-control" {...props} />
  }

  orderDateElTo(props) {
    return <input className="form-control" {...props} />
  }

  deliveryDateEl(props) {
    return <input className="form-control" {...props} />
  }

  deliveryDateElTo(props) {
    return <input className="form-control" {...props} />
  }

  openCodeForm() {
    this.setState({
      searchByCustomerCode: !this.state.searchByCustomerCode
    })
  }

  toggleByCode = () => {
    this.setState({
      searchByCustomerCode: !this.state.searchByCustomerCode,
      searchedCustomer: [],
      partSearchedCustomer: [],
      length: 0,
      showTable: false
    })
  }

  confirmSearchByCode = () => {
    let {selectedRadio} = this.state
    if (selectedRadio == '') {
      message.error('لطفا یک مشتری انتخاب کنید')
    } else {
      this.setState({
        selectedCustomerName: this.state.searchedCustomer[selectedRadio - 1].firstNameDto,
        selectedCustomerLastName: this.state.searchedCustomer[selectedRadio - 1].lastNameDto,
        selectedCustomerCode: this.state.searchedCustomer[selectedRadio - 1].codeDto,
        selectedCustomerMobile: this.state.searchedCustomer[selectedRadio - 1].phoneNumberDto,
        searchByCustomerCode: !this.state.searchByCustomerCode,
        customerId: this.state.searchedCustomer[selectedRadio - 1].idDto,
        readOnlyField: true,
        searchedCustomer: [],
        partSearchedCustomer: [],
        length: 0,
        showTable: false
      })
    }
  }

  searchByCode() {
    var CustomerCode = document.getElementById('CustomerCode').value
    var CustomerMobile = document.getElementById('CustomerMobile').value
    var CustomerFirstName = document.getElementById('CustomerFirstName').value
    var CustomerLastName = document.getElementById('CustomerLastName').value
    if (CustomerCode == '' && CustomerMobile == '' && CustomerFirstName == '' && CustomerLastName == '') {
      message.error('حداقل یکی فیلد وارد شود')
    } else {
      http
        .get(
          `${
            CRM.CRM_CONTACT_SEARCH_BY_CUSTOMER_INFO
          }?input_CustomerCode=${CustomerCode}&input_CustomerMobile=${CustomerMobile}&input_CustomerFirstName=${CustomerFirstName}&input_CustomerLastName=${CustomerLastName}`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            this.setState({
              selectedRadio: '',
              searchedCustomer: response.data.object,
              partSearchedCustomer: response.data.object.slice(0, 10),
              length: response.data.object.length,
              showTable: true,
              current: 1,
              pageSize: 10
            })
          } else {
            this.setState({
              searchedCustomer: [],
              partSearchedCustomer: [],
              showTable: false
            })
          }
        })
    }
  }

  onChangePage(pageNumber) {
    // alert(pageNumber)
    this.setState({
      current: pageNumber,
      partSearchedCustomer: this.state.searchedCustomer.slice((pageNumber - 1) * 10, pageNumber * 10)
    })

    // alert(JSON.stringify(this.state.partSearchedCustomer))
  }

  cancelByCode = () => {
    this.setState({
      searchByCustomerCode: !this.state.searchByCustomerCode,
      searchedCustomer: [],
      partSearchedCustomer: [],
      length: 0,
      showTable: false
    })
  }

  openFactorForm() {
    this.setState({
      searchByInvoiceNumber: !this.state.searchByInvoiceNumber
    })
  }

  toggleByInvoiceNum = () => {
    this.setState({
      searchByInvoiceNumber: true
    })
  }

  cancelByInvoiceNum = () => {
    this.setState({
      searchByInvoiceNumber: !this.state.searchByInvoiceNumber
    })
  }

  searchByInvoiceNumCustomer = () => {
    var input_CustomerCode = document.getElementById('customerCodeByInvoice').value
    var input_CustomerInvoiceId = document.getElementById('invoiceId').value
    var input_CustomerInvoiceNum = document.getElementById('invoiceNum').value
    var registerDate = this.convertDigit(document.getElementById('registerDate').value)
    var registerDateTo = this.convertDigit(document.getElementById('registerDateTo').value)
    var deliveryDate = this.convertDigit(document.getElementById('deliveryDate').value)
    var deliveryDateTo = this.convertDigit(document.getElementById('deliveryDateTo').value)
    // if(input_CustomerInvoiceId=='' && input_CustomerInvoiceNum=='' && input_CustomerCode == ''){
    //     message.error('حداقل فیلتر شناسه فاکتور و شماره فاکتور وارد شود')
    // }
    http
      .get(
        `${CRM.CRM_CONTACT_SEARCH_BY_CUSTOMER_INVOICE}?input_DeliveryDateMin=${
          deliveryDate == '' ? '' : this.epochFrom(deliveryDate)
        }&input_DeliveryDateMax=${deliveryDateTo == '' ? '' : this.epochTo(deliveryDateTo)}&input_RegistrationDateMin=${
          registerDate == '' ? '' : this.epochFrom(registerDate)
        }&input_RegistrationDateMax=${
          registerDateTo == '' ? '' : this.epochTo(registerDateTo)
        }&input_CustomerCode=${input_CustomerCode}&input_CustomerInvoiceId=${input_CustomerInvoiceId}&input_CustomerInvoiceNum=${input_CustomerInvoiceNum}&input_CustomerCode=${input_CustomerCode}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          // alert(response.data.object.length)
          console.log(response.data)
          this.setState({
            selectedRadio: '',
            searchedCustomer: response.data.object,
            partSearchedCustomer: response.data.object.slice(0, 10),
            length: response.data.object.length,
            showTable: true,
            current: 1,
            pageSize: 10
          })
        } else {
          this.setState({
            searchedCustomer: [],
            partSearchedCustomer: [],
            showTable: false
          })
        }
      })
  }

  confirmSearchByInvoiceNum = () => {
    let {selectedRadio} = this.state
    if (selectedRadio == '') {
      message.error('لطفا یک مشتری انتخاب کنید')
    } else {
      this.setState({
        selectedCustomerName: this.state.searchedCustomer[selectedRadio - 1].firstNameDto,
        selectedCustomerLastName: this.state.searchedCustomer[selectedRadio - 1].lastNameDto,
        selectedCustomerCode: this.state.searchedCustomer[selectedRadio - 1].codeDto,
        selectedCustomerMobile: this.state.searchedCustomer[selectedRadio - 1].mobileDto,
        searchByInvoiceNumber: !this.state.searchByInvoiceNumber,
        customerId: this.state.searchedCustomer[selectedRadio - 1].userIdDto,
        invoiceId: this.state.searchedCustomer[selectedRadio - 1].invoiceidDto,
        invoiceNum: this.state.searchedCustomer[selectedRadio - 1].invoiceNumDto,
        readOnlyField: true,
        searchedCustomer: [],
        partSearchedCustomer: [],
        length: 0,
        showTable: false
      })
    }
  }

  submit(e) {
    e.preventDefault()
  }

  newCustomer = () => {
    this.setState({
      readOnlyField: false,
      selectedCustomerName: '',
      selectedCustomerLastName: '',
      selectedCustomerCode: '',
      selectedCustomerMobile: ''
    })
  }

  onchangeSearch(e) {
    this.setState({
      selectedRadio: e.target.value
    })
  }

  changeField(e) {
    let target = e.target
    let value = target.value
    let name = target.name
    this.setState({
      [name]: value
    })
  }

  addComment() {
    var media = document.getElementById('media').value
    var category = document.getElementById('category').value
    var subject = document.getElementById('subject').value
    var definition = document.getElementById('definition').value
    var priority = document.getElementById('priority').value
    var comment = document.getElementById('comment').value
    var {
      selectedCustomerName,
      selectedCustomerMobile,
      selectedCustomerLastName,
      selectedCustomerCode,
      customerId,
      invoiceNum,
      invoiceId
    } = this.state
    var statusId = '1'

    var errorForm = false
    var mediaError = false
    var catError = false
    var subjectError = false
    var defError = false
    var priorityError = false
    var commentError = false
    var nameError = false
    var familyError = false
    var mobileError = false
    if (media == '') {
      errorForm = true
      mediaError = true
      message.error('رسانه تماس را مشخص کنید')
    } else {
      if (!mediaError) {
        this.setState({
          test: ''
        })
      }
    }
    if (category == '') {
      catError = true
      errorForm = true
      message.error('خانواده تماس را مشخص کنید')
    } else {
      if (!catError) {
        this.setState({
          test: ''
        })
      }
    }
    if (subject == '') {
      subjectError = true
      errorForm = true
      message.error('موضوع تماس را مشخص کنید')
    } else {
      if (!subjectError) {
        this.setState({
          test: ''
        })
      }
    }
    if (definition == '') {
      defError = true
      errorForm = true
      message.error('جزییات تماس مشخص شود')
    } else {
      if (!defError) {
        this.setState({
          test: ''
        })
      }
    }
    if (priority == '') {
      priorityError = true
      errorForm = true
      message.error('اولویت مشخص شود')
    } else {
      if (!priorityError) {
        this.setState({
          test: ''
        })
      }
    }
    if (selectedCustomerName == '' || selectedCustomerMobile == '' || selectedCustomerLastName == '') {
      nameError = true
      errorForm = true
      message.error('لطفا مشخصات شخصی کاربر کامل وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          test: ''
        })
      }
    }
    if (!errorForm) {
      alert('fdsf')
      let data = {
        input_contactMediaId: media,
        input_contactCategoryId: category,
        input_contactSubjectId: subject,
        input_contactDefinitionId: definition,
        input_contactStatusId: statusId,
        input_contactPriorityId: priority,
        input_mobile: selectedCustomerMobile.replace(/\+98/g, '0'),
        input_firstName: selectedCustomerName,
        input_lastName: selectedCustomerLastName,
        input_customerId: customerId,
        input_customerCode: selectedCustomerCode,
        input_invoiceId: invoiceId,
        input_invoiceNum: invoiceNum,
        input_comment: comment
      }
      http.post(`${CRM.CRM_CONTACT_MASTER_DETAIL_ADD}`, data, {}).then((response) => {
        if (response.data.error == null) {
          message.success('نظر مشتری با موفقیت ثبت شد')
        } else {
          message.error(response.data.description)
        }
      })
    }
  }

  render() {
    let pageNumber = this.state.current
    let {deliveryDate, orderDate, orderDateTo, deliveryDateTo} = this.state
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>ارتباط با مشتری</li>
          </ul>
          <div className="basketFilterComponent" style={{marginTop: '10px'}}>
            <div className="filterInputs">
              <div className="formComponent">
                <label>رسانه تماس : </label>
                <select className="form-control" id="media">
                  <option value="">------</option>

                  {this.state.mediaList.map((media, index) => (
                    <option value={media.contactMediaIdPkDto}>{media.contactMediaNameDto}</option>
                  ))}
                </select>
              </div>
              <div className="formComponent">
                <label>خانواده تماس : </label>
                <select className="form-control" id="category" onChange={this.changeCategory.bind(this)}>
                  <option value="">------</option>
                  {this.state.categoryList.map((category, index) => (
                    <option value={category.contactCategoryIdPkDto}>{category.contactCategoryNameDto}</option>
                  ))}
                </select>
              </div>
              <div className="formComponent">
                <label>موضوع تماس : </label>
                <select className="form-control" id="subject" onChange={this.changeSubject.bind(this)}>
                  <option value="">------</option>
                  {this.state.subjectList.map((subject, index) => (
                    <option value={subject.contactSubjectIdPkDto}>{subject.contactSubjectNameDto}</option>
                  ))}
                </select>
              </div>
              <div className="formComponent">
                <label>جزییات تماس : </label>

                <select className="form-control" id="definition">
                  <option value="">------</option>
                  {this.state.definitionList.map((definition, index) => (
                    <option value={definition.contactDefinitionIdPkDto}>{definition.contactDefinitionNameDto}</option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label>اولویت : </label>

                <select className="form-control" id="priority">
                  <option value="">------</option>
                  {this.state.priorityList.map((priority, index) => (
                    <option value={priority.contactPriorityIdDto}>{priority.contactPriorityNameDto}</option>
                  ))}
                </select>
              </div>

              <div className="formComponent">
                <label className="hiddenLabel">sdfdsf</label>

                <span onClick={this.openCodeForm.bind(this)} className="searchCRM">
                  ویرایش
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EditCrm
